import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ElementRef,
  inject,
  OnInit,
  Inject,
  input,
  ChangeDetectionStrategy,
  SimpleChanges,
} from '@angular/core';
import { ImageUploadService } from './image-upload.service';
import { CommonModule, DOCUMENT } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { SpinnerComponent } from '../spinner/spinner.component';
import { AngularModule, MaterialModule } from '@shared/modules';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-image-upload',
  standalone: true,
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AngularModule, MaterialModule, CommonModule, FormsModule],
})
export class ImageUploadComponent implements OnInit {
  @Input() fileUpload!: string;
  @Output() fileSelected = new EventEmitter<any>();

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  fileSizeInMB: number | null = null;
  imageUrl: string | null = null;
  isDeleteImage = input<boolean>(true);
  @Input() disabled: boolean = false;

  private readonly _cd = inject(ChangeDetectorRef);
  private readonly ng2ImgMax = inject(Ng2ImgMaxService);
  private readonly _toast = inject(ToastrService);

  constructor(
    private readonly imageUploadService: ImageUploadService,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fileUpload']) {
      const newValue = changes['fileUpload'].currentValue ?? '';

      this.imageUrl = newValue;

      this._cd.markForCheck();
    }
  }

  ngOnInit(): void {
    if (this.fileUpload && this.fileUpload !== '') {
      this.imageUrl = this.fileUpload;
    }
  }

  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const file: File | null = (event.target as HTMLInputElement).files?.[0] || null;
    if (file) {
      this.resizeImage(file);
    }
  }

  private resizeImage(file: File): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target?.result as string;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        if (ctx) {
          // Ancho máximo permitido
          const maxWidth = 100;
          const scaleSize = maxWidth / img.width;
          canvas.width = maxWidth;
          canvas.height = img.height * scaleSize;

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Convertir la imagen redimensionada a base64 con compresión
          // 70% calidad
          const compressedBase64 = canvas.toDataURL('image/jpeg', 0.7);

          this.imageUrl = compressedBase64;
          this.fileSelected.emit(compressedBase64);
          this._cd.markForCheck();
        } else {
          this._toast.error('Error al procesar la imagen', 'Error');
        }
      };
    };

    reader.onerror = (error) => {
      this._toast.error('Error al leer la imagen', 'Error');
    };
  }

  dropImage(): void {
    this.imageUrl = null;
    this.fileSelected.emit(this.imageUrl);
  }
}
